import isFeatureEnabled from '~/components/common/is-feature-enabled';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { APP_CONSTANTS } from '~/common/explicit-exports';

export default class AcademyBannerUtils {
  static getDefaultBannerImage(existingBanner, contentType) {
    if (existingBanner) return existingBanner;
    if (
      contentType === AssetPickerTypes.ACADEMY_CERTIFICATION ||
      contentType === APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.CERTIFICATION ||
      contentType === APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.PATH
    )
      return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_CERTIFICATION_BANNER;
    if (isFeatureEnabled('use_old_academy_default_content_banners')) return APP_CONSTANTS.DEFAULT_COVER_IMAGES.SERIES;

    switch (contentType) {
      case APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.GUIDE:
      case AssetPickerTypes.GUIDE:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_GUIDE_BANNER;
      case APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.RESOURCE:
      case AssetPickerTypes.RESOURCE:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_RESOURCE_BANNER;
      case APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.SCORM:
      case AssetPickerTypes.SCORM:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_SCORM_BANNER;
      case APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.EVENT:
      case AssetPickerTypes.ACADEMY_EVENT:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_EVENT_BANNER;
      case APP_CONSTANTS.ACADEMY_CUSTOM_PAGE_OBJECT_TYPES.COLLECTION:
      case AssetPickerTypes.ACADEMY_COLLECTION:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.ACADEMY_COLLECTION_BANNER;
      default:
        return APP_CONSTANTS.DEFAULT_COVER_IMAGES.SERIES;
    }
  }
}
